import React, { FunctionComponent, memo, ReactElement } from 'react'
import Grid from '@sport1/react-elements/Grid'
import { TestID } from '../../utils/PropTypesDefinitions'

export type PollabProgressLayoutProps = {
    children?: ReactElement
    progress?: number
} & TestID

const PollabProgressLayout: FunctionComponent<PollabProgressLayoutProps> = ({
    children,
    progress = 0,
    testID,
}) => {
    return (
        <Grid
            backgroundColor="moon-3"
            borderRadius={4}
            position="relative"
            noExpand
            testID={testID}
        >
            <Grid
                position="absolute"
                top={0}
                bottom={0}
                left={0}
                right={0}
                backgroundColor="tahitian-2"
                borderRadius={4}
                zIndex={1}
            />
            <Grid
                position="absolute"
                top={0}
                bottom={0}
                minWidth={`${Math.min(progress, 100)}%`}
                backgroundColor="moon-4"
                borderRadius={4}
                zIndex={2}
            />
            <Grid paddingX={16} paddingY={12} minHeight={0} centerVertical noExpand zIndex={3}>
                {children}
            </Grid>
        </Grid>
    )
}

export default memo(PollabProgressLayout)
